<ces-asset-breadcrumb [trail]="breadcrumbTrail()" />

<div class="p-(--padding-card)">
  <ces-route-title [count]="accessRightsDomain.length">
    @if (currentAssetId; as assetId) {
      <ces-button
        [hasPermission]="{ method: 'postAccessRightListResource', assetId: assetId }"
        [label]="'common.buttons.add' | transloco"
        icon="add"
        (onClick)="createAccessRight()" />
    }
  </ces-route-title>

  @if (!currentAssetId) {
    <div class="p-(--padding-card) text-center bg-yellow-100 border border-yellow-300 rounded-(--radius-md) mb-(--space-4)">
      <p>{{ 'common.messages.noAssetSelected.accessRights' | transloco }}</p>
    </div>
  }

  <ces-generic-parent-grid
    [hasPermission]="tablePermissionConfig()"
    (createEntity)="createAccessRight()"
    (deleteEntity)="deleteAccessRight($event)"
    (editEntity)="editAccessRight($event)"
    [dataLoadingCompleted]="dataLoadingCompleted"
    [entities]="accessRightsDomain"
    [entityDefinition]="entityDefinitionWithPermissions()" />
</div>
